import type { DatePickerDateRange } from '@/core/features/date-picker/date-picker-types';
import type { SchoolProductAvailabilityAttributes_jsonld_read } from '@/features/school-product-availability/school-product-availability-type';
import type { ReservationType } from '@/features/school-product-tiles-v2/school-product-tiles-v2-type';

import { dateToApiDate } from '@/core/features/date/date';
import { clientSideApiGetRequest } from '@/core/features/request/client-side-request';

const NEXT_API_SCHOOL_PRODUCT_AVAILABILITY_URL = '/booking/school-product-availability';

export async function getSchoolAvailabilityClientSide({
    productId,
    schoolId,
    selectedDateRange,
    type,
}: {
    productId: string;
    schoolId: number;
    selectedDateRange?: DatePickerDateRange;
    type: ReservationType;
}): Promise<SchoolProductAvailabilityAttributes_jsonld_read> {
    const searchParams = new URLSearchParams({ productId, schoolId: schoolId.toString() });

    if (selectedDateRange?.from) {
        searchParams.append('startDate', dateToApiDate(selectedDateRange.from));

        if (type === 'unscheduled' && selectedDateRange.to) {
            searchParams.append('endDate', dateToApiDate(selectedDateRange.to));
        }
    }

    const response = await clientSideApiGetRequest<SchoolProductAvailabilityAttributes_jsonld_read>(
        `${NEXT_API_SCHOOL_PRODUCT_AVAILABILITY_URL}?${searchParams.toString()}`,
    );

    return response.data;
}
